<script>
  export let items;
  export let play;

  function getThumb(thumbs) {
    if (thumbs.medium) {
      return thumbs.medium.url;
    }

    if (thumbs.high) {
      return thumbs.high.url;
    }
  }
</script>

<div class="bg"><img alt="Background" src="/img/b8c2ccf.png" class="bg" /></div>
<div class="videowall">
  {#each items as item (item.snippet.position)}
    <a
      href="/"
      on:click={(ev) => {
        ev.preventDefault();
        play(item.snippet.resourceId.videoId);
      }}
      class="video"
    >
      <div>
        <svg
          on:click={(ev) => {
            ev.preventDefault();
            play(item.snippet.resourceId.videoId);
          }}
          class="play-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
            clip-rule="evenodd"
          />
        </svg>
        <img
          alt={item.snippet.title}
          loading="lazy"
          src={getThumb(item.snippet.thumbnails)}
          class="image"
        />
      </div>
    </a>
  {/each}
</div>

<style>
  .videowall {
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: default;
    position: relative;

    max-width: 1000px;
    margin: 7% auto;
  }
  .video {
    line-height: 0;
    margin-left: 3px;
    position: relative;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: inline-block;
    cursor: pointer;
    overflow: hidden;
    color: inherit;
    text-decoration: none;
    outline: 0;
    opacity: 1;
  }
  .image {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    color: inherit;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    pointer-events: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-touch-callout: none;
  }
  .play-icon {
    width: 20%;
    height: 20%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .play-icon:active {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: 0;
    fill: yellowgreen;
  }

  .bg img {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: blur(10px);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-top: -15%;
  }
</style>
